export const photos = [
  {
    id: 1,
    country: 'usa',
    location: 'cape-cod',
    name: 'Cape Cod'
  },
  {
    id: 2,
    country: 'usa',
    location: 'cape-cod',
    name: 'Cape Cod'
  },
  {
    id: 3,
    country: 'usa',
    location: 'cape-cod',
    name: 'Cape Cod'
  },
  {
    id: 4,
    country: 'usa',
    location: 'cape-cod',
    name: 'Cape Cod'
  },
  {
    id: 5,
    country: 'usa',
    location: 'cape-cod',
    name: 'Cape Cod'
  },
  {
    id: 6,
    country: 'usa',
    location: 'cape-cod',
    name: 'Cape Cod'
  },
  {
    id: 7,
    country: 'usa',
    location: 'cape-cod',
    name: 'Cape Cod'
  },
  {
    id: 8,
    country: 'usa',
    location: 'cape-cod',
    name: 'Cape Cod'
  },
  {
    id: 9,
    country: 'usa',
    location: 'cape-cod',
    name: 'Cape Cod'
  }
 
]